// 

(function($){
    $( "#tabs" ).tabs({
        show:500, hide: 300
    });
    

	$('form.brochure--webform input[type=submit]').click(function(){
		if(ga) {
			/*ga('send', 'event', {
				eventCategory: 'forms',
				eventAction: 'download',
				eventLabel: 'brochure',
				transport: 'beacon'
			  });*/
			ga('send', 'event', 'download', 'brochure', {transport: 'beacon'});
		}
		if(gtag) {
			gtag('event', 'download', {
				  'event_category': 'brochure',
				  'transport_type': 'beacon'
				});
		}
	});
  

    $(window).scroll(function() {  
		  
        var scroll = $(window).scrollTop();

        if (scroll >= 40) {
            $('.menu--principal').addClass('scroll_active');
            $('.lang').addClass('not-active');
            $('header').addClass('menu_scroll');
            $('.secondary-menu--scroll').addClass('secondary-menu--active' , 500);
           

        } else {
            $('.menu--principal').removeClass('scroll_active' , 500);
            $('header').removeClass('menu_scroll');
            $('.lang').removeClass('not-active');
            $('.secondary-menu--scroll').removeClass('secondary-menu--active' , 500);
           
            
		}
		
        if (scroll >= 400) {
            $('.share').addClass('scroll_active');

        } else {
            $('.share').removeClass('scroll_active' , 500);
           
            
        }
	});
	

    $('.burger-menu').click(function() {
        if ($(".secondary-menu--active").css("right") == "-200px") {
            $('.secondary-menu--active').animate({right: '0px'});
			$(this).addClass('active');
		
			
            
        } else {
            $('.secondary-menu--active').animate({right: '-200px'});
            $(this).removeClass('active');
        }
	});

	


$('[data-fancybox="gallery"]').fancybox({
});
	

    setTimeout(function () { $('.flexslider .flex-control-nav').find('li').append('<span>') }, 1000);

    setTimeout(function () {  
        $('.choice-systeme li').click(function() {
            $('.choice-systeme li').toggleClass('active-responsive');
            $('.choice-systeme li').toggleClass('ui-state-active-open');
        }); 
}, 1000);


    var swiper = new Swiper('.swiper-container', {
        slidesPerView: 2,
        spaceBetween: 30,
        // init: false,
        scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
        },
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		  },
        breakpoints: {
            
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            720: {
              slidesPerView: 2,
              spaceBetween: 20
            },
          }
    });
   
    $('select#edit-filter-type-realisation').addClass('js-example-basic-multiple');
    $('select#edit-filter-type-realisation').select2({
        tags: "true",
        placeholder: "Faites votre choix",
        closeOnSelect: false
      });

      $('.burger-menu--responsive').click(function() {
        $('.menu--mobile').toggleClass('menu--mobile-actif');
        $('body').toggleClass('fixed');
        $('.menu--position').toggleClass('burger-menu--responsive-actif');
    }); 

    var loadmap = setInterval(function(){
    if( typeof google.maps.Map == 'function' ) {
        
        if( $('.google-map').length > 0 ) {
            var latlng = {lat: 50.096374184273884, lng: 4.506435769410484}; 
            
            $('.google-map').each(function(){
                
                var map = new google.maps.Map(this, {
                  zoom: 15,
					center: latlng,
					styles: [
						{
							"featureType": "administrative",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#6195a0"
								}
							]
						},
						{
							"featureType": "landscape",
							"elementType": "all",
							"stylers": [
								{
									"color": "#f2f2f2"
								}
							]
						},
						{
							"featureType": "landscape",
							"elementType": "geometry.fill",
							"stylers": [
								{
									"color": "#f4f4f4"
								}
							]
						},
						{
							"featureType": "poi",
							"elementType": "all",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "poi.park",
							"elementType": "geometry.fill",
							"stylers": [
								{
									"color": "#e6f3d6"
								},
								{
									"visibility": "on"
								}
							]
						},
						{
							"featureType": "road",
							"elementType": "all",
							"stylers": [
								{
									"saturation": -100
								},
								{
									"lightness": 45
								},
								{
									"visibility": "simplified"
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "all",
							"stylers": [
								{
									"visibility": "simplified"
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "geometry.fill",
							"stylers": [
								{
									"color": "#f5c200"
								},
								{
									"visibility": "simplified"
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "labels.text",
							"stylers": [
								{
									"color": "#4e4e4e"
								}
							]
						},
						{
							"featureType": "road.arterial",
							"elementType": "geometry.fill",
							"stylers": [
								{
									"color": "#f4f4f4"
								}
							]
						},
						{
							"featureType": "road.arterial",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#787878"
								}
							]
						},
						{
							"featureType": "road.arterial",
							"elementType": "labels.icon",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "transit",
							"elementType": "all",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "water",
							"elementType": "all",
							"stylers": [
								{
									"color": "#eaf6f8"
								},
								{
									"visibility": "on"
								}
							]
						},
						{
							"featureType": "water",
							"elementType": "geometry.fill",
							"stylers": [
								{
									"color": "#eaf6f8"
								}
							]
						}
					]
                });
				var image = "/themes/custom/stabilame/assets/src/images/icon_marker.png";
                var marker = new google.maps.Marker({
                  position: latlng,
                  map: map,
				  title: 'Hello World!',
				  icon: image
                });
                
               
                
                marker.addListener('click', function() {
                   
                });
                               
            })
            
        }        
        clearInterval(loadmap);
	}

	
	$('.close--brochure').click(function() {
		$("section.brochure").fadeOut(400);
	});
	$('.button-close').click(function() {
		$(".block_message-thanks").fadeOut(400);
	});

	
    $('ul.menu li:nth-child(4)').click(function() {
		$("section.brochure").fadeIn(400);
        $(".block_message-thanks").fadeOut(400);
	});
    $('.menu--mobile ul:not(.subfooter--mobile) li:nth-child(1)').click(function() {
        $("section.brochure").fadeIn(400);
	});
   
}, 200);



})(jQuery);




